import { useEffect, useState } from "react";
import AppTable from "../../common/app-table";
import AppChip from "../../common/app-chip";
import { INSTAGRAM_AUDIT } from "../../config/urls";
import { Section, formatDate, useInstagramApi } from "./shared";

// Spec 11 "Roles and permissions", shown as a tab on Instagram Analytics.

const PERMISSIONS = [
  { action: "Connect, reconnect, disconnect", admin: true, manager: false, user: false },
  { action: "Ice breakers, business hours, routing", admin: true, manager: true, user: false },
  { action: "Create and edit rules", admin: true, manager: true, user: false },
  { action: "Reply in inbox and comments", admin: true, manager: true, user: true },
  { action: "View analytics", admin: "All chats", manager: "All chats", user: "Own chats" },
];
const ROLE_LABEL = { admin: "Admin / Owner", manager: "Manager", user: "Agent" };

const allowed = (value) => (value === false
  ? <AppChip label="No" color="default" variant="outlined" />
  : <AppChip label={value === true ? "Yes" : value} color="success" variant="outlined" />);

export const RolesTab = ({ role }) => {
  const { request } = useInstagramApi();
  const [events, setEvents] = useState(null);
  const canAudit = role === "admin" || role === "manager";

  useEffect(() => {
    if (canAudit) request("get", INSTAGRAM_AUDIT).then((res) => setEvents(res.events || [])).catch(() => setEvents([]));
  }, [request, canAudit]);

  return (
    <>
      <Section title="Roles and permissions" sx={{ mb: 3 }}
        hint={`Your role: ${ROLE_LABEL[role] || "—"}. Change roles in MANAGE › Users.`}>
        <AppTable
          rows={PERMISSIONS}
          rowKey={(p) => p.action}
          columns={[
            { id: "action", label: "Action" },
            ...Object.entries(ROLE_LABEL).map(([key, label]) => ({
              id: key, label: key === role ? `${label} (you)` : label, render: (p) => allowed(p[key]),
            })),
          ]}
        />
      </Section>
      {canAudit && (
        <Section title="Audit log" hint="The last 100 Instagram changes, who made them and why.">
          <AppTable
            loading={events === null}
            maxHeight={480}
            rows={events || []}
            emptyMessage="Nothing logged yet"
            columns={[
              { id: "created_at", label: "When", render: (e) => formatDate(e.created_at) },
              { id: "action", label: "Event", render: (e) => <AppChip label={e.action} variant="outlined" /> },
              { id: "account_username", label: "Account", render: (e) => (e.account_username ? `@${e.account_username}` : "—") },
              { id: "actor_name", label: "By", render: (e) => e.actor_name || "system" },
              { id: "data", label: "Details", render: (e) => e.data?.reason || e.data?.name || e.data?.error || "—" },
            ]}
          />
        </Section>
      )}
    </>
  );
};
